<ng-template #createNewBrokerageTemplate let-item>
	<div class="flex justify-between">
		<span class="mr-3 whitespace-nowrap">{{ fireInsuranceBrokerageName }}</span>
		<app-button
			(click)="create()"
			[icon]="ICON.ADD"
			size="small"
			[cssClasses]="['button', 'text-xs']"
			[testHook]="testHooks.CreateBrokerageButton"
			>Create Brokerage</app-button
		>
	</div>
</ng-template>

<ng-template #fireInsuranceBrokerageTemplate let-item>
	<div
		class="flex flex-col"
		[testHook]="testHooks.FireInsuranceBrokerageItemDiv"
	>
		<span class="font-bold truncate">{{ item.name | titlecase }}</span>
		<div class="flex truncate">
			<span class="text-sm"
				>{{ item.address?.street }}, {{ item?.address?.city }}</span
			>
		</div>
	</div>
</ng-template>

<div class="py-2">
	<app-auto-complete
		placeholder="Fire insurance Brokerage"
		[itemGroups]="[
			{ items: [{ value: 'createNew' }], template: createNewBrokerageTemplate },
			{
				items: (fireInsuranceBrokerage$ | async),
				template: fireInsuranceBrokerageTemplate,
				title: 'Fire insurance brokerage',
				noResultsMessage: 'No Fire insurance brokerages found',
				type: dropdownSelect.SELECT_FIRE_INSURANCE_BROKERAGE,
			},
		]"
		[(ngModel)]="fireInsuranceBrokerageName"
		[minSearchTerm]="2"
		[loading]="loading"
		width="w-full"
		(debounce)="search($event)"
		[label]="label"
		(onSelect)="onSelectFireInsuranceBrokerage($event)"
		[testHook]="testHooks.FireInsuranceBrokerageNameAutoComplete"
	>
	</app-auto-complete>
</div>
